import { Locale } from "./locale.type";

export default {
  title: "CalmSteps",
  view: "Visa",
  recentViews: "Nyligen visade",
  delete: "Ta bort",
  edit: "Redigera",
  done: "Klar",
  create: "Skapa",
  enterCode: "Ange kod",
  back: "Tillbaka",
  notFound: {
    title: "Inte hittad",
    description: "Ingen vy hittad för kod",
  },
  offline: {
    cachedVersion: "Visar cachad version",
    notAvailable: "Inte tillgänglig offline",
    notAvailableDescription: "Öppna denna vy online först för att aktivera offlineåtkomst.",
  },
} satisfies Locale;
